// Direct HTTPS call to our Cloud Function — bypasses Firebase JS SDK's
// httpsCallable, which hangs inside Capacitor's WKWebView (same class of bug
// as CSP's Firestore-via-Capacitor issue).

const FUNCTION_URL = `https://us-central1-${import.meta.env.VITE_FIREBASE_PROJECT_ID}.cloudfunctions.net/analyzeImage`;

export async function analyzeImage({ base64, mimeType, category }) {
  const res = await fetch(FUNCTION_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ base64, mimeType, category }),
  });
  if (!res.ok) {
    let detail = '';
    try { detail = (await res.json()).error || ''; } catch {}
    throw new Error(`Analysis failed (${res.status})${detail ? ': ' + detail : ''}`);
  }
  const { fields } = await res.json();
  return fields || {};
}
